// The Catchy Chat / AI Hub guide (61_AiHub.jsx · ModuleHelp, Max 01/11).
const en = {
  convsT: 'Your conversations',
  convsB: 'Every chat you have had with Catchy is kept here. New chat starts a fresh one; open an old one to carry on, and rename or delete it when you no longer need it.',
  scopeT: 'Which department to ask',
  scopeB: 'Choose a department so Catchy answers from that department\'s instructions and files, or leave it on all departments.',
  threadT: 'The answers',
  threadB: 'Catchy answers with sources you can open to check. Mark an answer good, or send a correction with the thumbs-down so the right answer is kept as a lesson.',
  inputT: 'Ask your question',
  inputB: 'Write the question in your own words. Enter sends it and Shift+Enter starts a new line.',
  sendT: 'Send',
  sendB: 'Sends the question to Catchy. While it is working you will see a thinking line; the answer appears in the thread above.',
};
const ko = {
  convsT: '내 대화',
  convsB: 'Catchy와 나눈 모든 대화가 여기에 저장됩니다. 새 대화로 처음부터 시작하고, 이전 대화를 열어 이어가며, 필요 없으면 이름을 바꾸거나 삭제하세요.',
  scopeT: '질문할 부서',
  scopeB: '부서를 고르면 Catchy가 그 부서의 지침과 파일을 바탕으로 답합니다. 전체 부서로 두어도 됩니다.',
  threadT: '답변',
  threadB: 'Catchy는 직접 열어 확인할 수 있는 출처와 함께 답합니다. 답변을 좋음으로 표시하거나, 싫어요로 수정 답을 보내면 올바른 답이 교훈으로 저장됩니다.',
  inputT: '질문 입력',
  inputB: '질문을 편하게 써 주세요. Enter로 전송하고 Shift+Enter로 줄을 바꿉니다.',
  sendT: '보내기',
  sendB: '질문을 Catchy에게 보냅니다. 처리 중에는 생각 중 표시가 나오고, 답변은 위 대화창에 표시됩니다.',
};
const vi = {
  convsT: 'Các cuộc trò chuyện của bạn',
  convsB: 'Mọi cuộc trò chuyện của bạn với Catchy được giữ ở đây. Chat mới bắt đầu một cuộc mới; mở cuộc cũ để nói tiếp, đổi tên hoặc xóa khi không cần nữa.',
  scopeT: 'Hỏi phòng ban nào',
  scopeB: 'Chọn một phòng ban để Catchy trả lời theo hướng dẫn và tệp của phòng ban đó, hoặc để ở tất cả phòng ban.',
  threadT: 'Các câu trả lời',
  threadB: 'Catchy trả lời kèm nguồn để bạn mở ra kiểm tra. Đánh dấu câu trả lời tốt, hoặc gửi bản sửa bằng nút không thích để câu đúng được lưu thành bài học.',
  inputT: 'Đặt câu hỏi',
  inputB: 'Viết câu hỏi theo cách bạn nói. Enter để gửi, Shift+Enter để xuống dòng.',
  sendT: 'Gửi',
  sendB: 'Gửi câu hỏi cho Catchy. Trong lúc xử lý bạn sẽ thấy dòng đang suy nghĩ; câu trả lời hiện ở khung trò chuyện phía trên.',
};
const zh = {
  convsT: '你的对话',
  convsB: '你与 Catchy 的所有对话都保存在这里。新对话会重新开始；打开旧对话可以继续，不需要时可重命名或删除。',
  scopeT: '向哪个部门提问',
  scopeB: '选择一个部门，Catchy 会依据该部门的说明和文件回答；也可以保持为所有部门。',
  threadT: '回答',
  threadB: 'Catchy 的回答附有来源，可打开核对。可以把回答标记为有用，或用点踩提交更正，正确的答案会被保存为经验。',
  inputT: '输入问题',
  inputB: '用自己的话写下问题。按 Enter 发送，Shift+Enter 换行。',
  sendT: '发送',
  sendB: '把问题发给 Catchy。处理时会显示思考中的提示，回答会出现在上方的对话区。',
};
const dictionary = { ns: 'tourAiHub', en, ko, vi, zh };
export default dictionary;
